<div class="z-3 scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button class="btn btn-dark" (click)="scrollToTop()">
    <i class="fa fa-chevron-up"></i>
  </button>
</div>
